import React, { Component } from "react";
import { connect } from "react-redux";
// import Footer from "./Footer";
import { PageRoom } from "./PageRoom";
import { PageSettings } from "./PageSettings";
import styled from "styled-components";
import FixedClock from "../lib/FixedClock";
import { selectCanShowRoom } from "../redux/selectors.js";

/* Set up main variables here. In styled-components we don't have access to Bulma's Sass variables like $foo
so we use standard CSS variables instead. */
const AppDiv = styled.div`
    --panel-bg-colour: #151520;
    --panel-fg-colour: #eeeeee;
    height:100%;
`;

export class UnconnectedMain extends Component {

    constructor(props) {
        super(props);
        FixedClock.setClockDrift();
    }

    render() {

      return (
          <AppDiv className="App">
              { this.props.selectCanShowRoom ? <PageRoom /> : <PageSettings />}
          </AppDiv>
      );
    }

}

const mapStateToProps = state => ({ 
  selectCanShowRoom: selectCanShowRoom(state),
});
export const Main = connect(mapStateToProps, {} )(UnconnectedMain);


